/** @file One pointer-move step of a drag-scrub: pixels become value units, shift makes it fine. */
import { clamp } from '@pose2d/math/clamp';
import type { NumberBounds } from './constrainNumber';
import { fineFactor } from './fineFactor';

/** Unrounded value being scrubbed, the last pointer x, and whether the pointer ever moved. */
export interface ScrubSession {
  raw: number;
  lastX: number;
  moved: boolean;
}

/** Returns the session after the pointer reached `clientX`: one pixel is one `step`, or a tenth of it when `fine`. */
export function advanceScrub(session: ScrubSession, clientX: number, fine: boolean, step: number, bounds: NumberBounds): ScrubSession {
  const dx = clientX - session.lastX;
  if (dx === 0) return session;
  const raw = clamp(session.raw + dx * step * (fine ? fineFactor : 1), bounds.min ?? -Infinity, bounds.max ?? Infinity);
  return { raw, lastX: clientX, moved: true };
}
